export default "__VITE_ASSET__BVdUfgbF__"